module.exports = __webpack_public_path__ + "img/corriente_c_blue.48cfb607.svg";